import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
// import modules
import root from '@/modules/root';
import auth from '@/modules/auth';
import nav from '@/modules/nav';
import config from '@/modules/config';
import { logCommit, logAction } from '@/helpers/log';
export const store = new Vuex.Store({
    modules: {
        root,
        auth,
        nav,
        config
    }
});
if (process.env.VUE_APP_LOG_ENABLED == 'y') {
    store.subscribe((mutation, state) => {
        logCommit(mutation);
    });
    store.subscribeAction({
        before: (action, state) => {
            logAction(action);
        },
        after: (action, state) => { }
    });
}
export default store;
